import React from "react";
import FormWrapper from "@mbdb_deposit/buildingBlocks/FormWrapper";
import ValueUnit from "@mbdb_deposit/buildingBlocks/ValueUnit";

export default function ShakingSpeed({ colorSchema, name }) {
  const unitOptions = [{ value: "RPM", label: "RPM" }];

  return (
    <>
      <div className="w-fit">
        <FormWrapper
          colorSchema={colorSchema}
          headline="Shaking speed"
          tooltip="The numerical value of the shaking speed of the plate during the measurement step"
          name={name}
        >
          <ValueUnit
            options={unitOptions}
            name={name}
            tooltipValue="The numerical value of the shaking speed of the plate during the measurement step"
            tooltipUnit="The unit of the shaking/stirring speed"
            valueRequired
            unitRequired
          />
        </FormWrapper>
      </div>
    </>
  );
}
